module.exports = __webpack_public_path__ + "img/scrub4.8fa885ba.jpg";